import { QuestelServicesClient, RequestResult } from '@questelservices/common/dist';
import store from '@/store';
import { ClientAgentInfoDto } from '../models/client-agent/ClientAgentInfoDto';
import { UpdateClientAgentJurisdictionDto } from '@/models/client-agent/ClientAgentJurisdictionDto';
import { AgentDto } from '@/models/agent/AgentDto';
import { LinkClientAgentDto } from '@/models/client-agent/LinkClientAgentDto';

export class ClientAgentService {
  private client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, "/api/clientagents");
  }

  async agentSetup(options: any): Promise<any> {
    return await this.client.getPostData(`/agent-setup`, options); 
  }

  async getExistingClientAgentData(clientId: Guid, agentName: string): Promise<ClientAgentInfoDto> {
    return await this.client.getPostData(`/${clientId}`, agentName);
  }

  async getExistingClientAgentDataByAlias(agentAlias: string): Promise<ClientAgentInfoDto> {
    return await this.client.getPostData('/agent-setup-existing-alias', agentAlias);
  }

  async getUnsetCountries(clientId: Guid, agentId: Guid) {
    return await this.client.get(`/unset-countries/${clientId}/${agentId}`);
  }

  async createClientAgentData(agentInfo: ClientAgentInfoDto) : Promise<Guid[]> {    
    let result = await this.client.postJson<Guid[]>('/agent-setup-create', agentInfo);
    return result.Data ? result.Data : [];
  }

  async updateClientAgentData(agentInfo: ClientAgentInfoDto) : Promise<Guid[]> {  
    let result = await this.client.postJson<Guid[]>('/agent-setup-update', agentInfo);
    return result.Data ? result.Data : [];
  }

  async updateClientAgentJurisdiction(jurisdictionDto: UpdateClientAgentJurisdictionDto): Promise<any> {
    return await this.client.postJson('/agent-jurisdiction-update', jurisdictionDto);
  }

  async getClientAgentForReport(clientId: Guid, options: any) : Promise<any> {
    return await this.client.postJson(`/${clientId}/associated-agents`, options);
  }

  async setClientAgentToReceiveReport(clientId: Guid, clientAgentIds: number[]): Promise<any> {
    return await this.client.postJson(`/${clientId}/receive-report`, clientAgentIds);
  }

  async getUnlinkedAgents(clientId: Guid): Promise<AgentDto[]> {
    return await this.client.get(`/unlinked-agents/${clientId}`);
  }

  async linkClientAndAgent(linkClientAgentDto: LinkClientAgentDto): Promise<any> {
    return await this.client.postJson('/link-client-and-agent', linkClientAgentDto);    
  }
}